 

mutation CompanyCardCompanyUpdate($input: CompanyCardCompanyUpdateInput!) {
  companyCardCompanyUpdate(
    input: $input
  ) {
      companyCardCompany {
      cardCompanyId
      apiKey
      _cardCompanyName
    }
  }
}

 